import types from "./types";

export function allCarros() {
  return { type: types.ALL_CARROS};
}
export function allReservaCarro() {
  return { type: types.ALL_HORARIOS_RESERVA};
}
export function allReservaCarroCliente() {
  return { type: types.ALL_CARROS_CLIENTE_RESERVA};
}
export function updateReservaCarro(payload) {
    return { type: types.UPDATE_HORARIO_RESERVA , payload};
  }
  
  export function filterReservaCarro() {
    return { type: types.FILTER_HORARIO_RESERVA };
  }
  
  export function resetReserva() {
    return { type: types.RESET_HORARIO_RESERVA };
  }

  export function addReservation() {
    return { type: types.ADD_HORARIO_RESERVATION };
  }
  export function canselarReserva() {
    return { type: types.REMOVE_HORARIO_RESERVA };
  }